export default __webpack_public_path__ + "static/form-default-values-do-14b058184ac1b915ddf8e0e0a58c97b2.png";